import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const ChiefLogin = () => {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Try signup first; fall back to login on 400 (existing user)
      let response = await fetch('/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email, password,
          adminuserid: window.APPSETTING.adminuserid,
          appname:     window.APPSETTING.appname,
        }),
      });
      let data = await response.json();

      if (!response.ok) {
        if (response.status === 400) {
          response = await fetch('/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email, password,
              adminuserid: window.APPSETTING.adminuserid,
              appname:     window.APPSETTING.appname,
            }),
          });
          data = await response.json();
          if (!response.ok) throw new Error(data.error || 'Login failed');
        } else {
          throw new Error(data.error || 'Signup failed');
        }
      }

      window.APPUSER = data;
      localStorage.setItem(window.APPSETTING.appname + 'user', JSON.stringify(data));
      setTimeout(() => navigate('/dashboard'), 600);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chief-form-wrap">
      <div className="chief-form-card">
        <h2>Welcome back</h2>
        <p className="form-sub">Sign in to your Chief of Staff console</p>

        {error && <div className="chief-form-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="chief-fg">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </div>
          <div className="chief-fg">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            className="btn-gold"
            style={{ width: '100%', marginTop: '8px' }}
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Continue →'}
          </button>
        </form>

        <p style={{ marginTop: '20px', fontSize: '0.82rem', color: 'var(--muted)', textAlign: 'center' }}>
          New here?{' '}
          <Link to="/signup" style={{ color: 'var(--gold)' }}>Create account</Link>
        </p>
      </div>
    </div>
  );
};

export default ChiefLogin;
